import React, { useEffect, useRef, useState } from "react";
import "../index.css";
import johnnieWalker from "../../../assets/mp4/johnnieWalker.mp4";

import ScrollAnimado from "../../ScrollAnimado";
import ModalVideo from "../../ModalVideo";

export default function JohnnieWalker() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [linkVideo, setLinkVideo] = useState("");
  window.addEventListener("scroll", () => {
    setMenuAberto(false);
  });

  return (
    <>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={johnnieWalker} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>

        <div
          className="tituloHome tituloHome1 "
          onClick={() => {
            setLinkVideo(
              "https://player.vimeo.com/video/1077944931?h=42be6d6f53"
            );
          }}
        >
          Johnnie Walker
        </div>

        <div className="background"></div>
      </div>
    </>
  );
}
